var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          {
            staticClass: "form-wrapper",
            attrs: { validator: _vm.$v.costLine },
          },
          [
            _c(
              "div",
              { staticClass: "item-description" },
              [
                _c(
                  "form-group",
                  { attrs: { label: "Description" } },
                  [
                    _c("md-input", {
                      attrs: { disabled: _vm.costLine.type === "surcharge" },
                      model: {
                        value: _vm.costLine.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.costLine, "description", $$v)
                        },
                        expression: "costLine.description",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item-unit" },
              [
                _c(
                  "form-group",
                  { attrs: { label: "Unit" } },
                  [
                    _c("md-input", {
                      attrs: {
                        disabled: !_vm.costLine.isBaseCharge,
                        value: _vm.costLine.chargeUnit,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onCostUnitInput($event)
                        },
                      },
                    }),
                    _vm.costLine.isBaseCharge && _vm.costLine.type === "hourly"
                      ? _c("div", { staticClass: "unit-charge-info" }, [
                          _vm._v("Enter minutes eg. 65"),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item-unitPriceExTax" },
              [
                _c(
                  "form-group",
                  { attrs: { name: "amount", label: "Amount" } },
                  [
                    _c("md-input", {
                      model: {
                        value: _vm.costLine.unitPriceExTax,
                        callback: function ($$v) {
                          _vm.$set(_vm.costLine, "unitPriceExTax", _vm._n($$v))
                        },
                        expression: "costLine.unitPriceExTax",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-primary dialog-button",
            on: { click: _vm.addCostItem },
          },
          [_vm._v("\n            Save\n        ")]
        ),
        _c(
          "md-button",
          {
            staticClass: "md-default dialog-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeCostItem($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Add Cost item")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }